export default __webpack_public_path__ + "static/media/js.c7aa1177.svg";